import { render, staticRenderFns } from "./fans-config.vue?vue&type=template&id=4326983f&scoped=true"
import script from "./fans-config.vue?vue&type=script&lang=js"
export * from "./fans-config.vue?vue&type=script&lang=js"
import style0 from "./fans-config.vue?vue&type=style&index=0&id=4326983f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4326983f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4326983f')) {
      api.createRecord('4326983f', component.options)
    } else {
      api.reload('4326983f', component.options)
    }
    module.hot.accept("./fans-config.vue?vue&type=template&id=4326983f&scoped=true", function () {
      api.rerender('4326983f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/common/fans-config.vue"
export default component.exports